import axiosConfig from "./axiosConfig";

const deleteAxpoSiteNameMapping = async (
  authToken: string,
  siteId: string
): Promise<void> => {
  const { data } = await axiosConfig.delete(
    `/admin/axpo-counter-invoice/site-name-mappings/${siteId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default deleteAxpoSiteNameMapping;
